(ns dashboard.views.browser-extension.search.view
  (:require
   [dashboard.components.search.view :as search-view]))

(defn search []
  [search-view/quick-search true])
